/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PartnerAccountRemoveAppData model module.
 * @module model/PartnerAccountRemoveAppData
 * @version 1.0
 */
class PartnerAccountRemoveAppData {
    /**
     * Constructs a new <code>PartnerAccountRemoveAppData</code>.
     * @alias module:model/PartnerAccountRemoveAppData
     */
    constructor() { 
        
        PartnerAccountRemoveAppData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PartnerAccountRemoveAppData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PartnerAccountRemoveAppData} obj Optional instance to populate.
     * @return {module:model/PartnerAccountRemoveAppData} The populated <code>PartnerAccountRemoveAppData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PartnerAccountRemoveAppData();

            if (data.hasOwnProperty('appTitle')) {
                obj['appTitle'] = ApiClient.convertToType(data['appTitle'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PartnerAccountRemoveAppData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PartnerAccountRemoveAppData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['appTitle'] && !(typeof data['appTitle'] === 'string' || data['appTitle'] instanceof String)) {
            throw new Error("Expected the field `appTitle` to be a primitive type in the JSON string but got " + data['appTitle']);
        }

        return true;
    }


}



/**
 * @member {String} appTitle
 */
PartnerAccountRemoveAppData.prototype['appTitle'] = undefined;






export default PartnerAccountRemoveAppData;

